import { IconTextButton, Tooltip } from "@smartsuite/react-ui/lib";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import { AddConditionStyles } from "./style";
import type React from "react";
import { useRootStore } from "../../../../../../stores/hooks";
import { GrayColors, SolutionColorVariables } from "@smartsuite/types";

export const AddConditionsButton = observer<{
  onClick: () => void;
  isAllowAdd: boolean;
}>(({ onClick, isAllowAdd }) => {
  const { maxTriggerConditions } = useRootStore().featureFlags.limits;

  const getButton = (disabled?: boolean): React.ReactElement => (
    <AddConditionStyles>
      <IconTextButton
        disabled={disabled}
        iconName="plus-circle"
        iconStyle={{
          size: "M",
          marginRight: 10,
          color: disabled ? GrayColors["G-3"] : SolutionColorVariables.sc1,
          hoverColor: SolutionColorVariables.sc3,
        }}
        textStyle={{
          size: "s",
          weight: "medium",
          color: disabled ? GrayColors["G-3"] : SolutionColorVariables.sc1,
          hoverColor: SolutionColorVariables.sc3,
        }}
        onClick={onClick}
      >
        {t("trigger-section.add-condition")}
      </IconTextButton>
    </AddConditionStyles>
  );

  return (
    <>
      {isAllowAdd ? (
        getButton()
      ) : (
        <Tooltip
          text={t("trigger-section.reached-max-condition-count", {
            number: maxTriggerConditions,
          })}
          target={getButton(true)}
        />
      )}
    </>
  );
});
